import { useMemo } from "react";
import stringify from "fast-json-stable-stringify";

export function useStableReferenceValue<T>(value: T): T {
    return useMemo(() => value, [stringify(value)]);
}
